import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["contents"];

  connect() {
    if (this.hasResult()) return;
    if (this._pollingId) clearInterval(this._pollingId);

    this._pollingId = setInterval(() => {
      if (this.hasResult()) {
        clearInterval(this._pollingId);
        this._pollingId = null;
        return;
      }
      if (this.contentsTarget) {
        this.contentsTarget.reload();
      }
    }, 2000);
  }

  disconnect() {
    if (this._pollingId) {
      clearInterval(this._pollingId);
      this._pollingId = null;
    }
  }

  hasResult() {
    return !!(this.contentsTarget && this.contentsTarget.querySelector(".shindan-result"));
  }
}
